/**
 * Canonical role display helpers - one home for role chip colors and
 * labels so admin tables, filters, summary cards and layout account
 * surfaces never drift. Two color models on purpose: getRoleColor returns
 * MUI Chip color tokens (admin tables), getRoleHexColor returns raw hex
 * for `sx={{ bgcolor }}` chips on the dark layout headers.
 */

export type RoleChipColor = 'error' | 'primary' | 'warning' | 'success' | 'default'

export const ROLE_ORDER = ['FP_USER', 'PSC_TEAM', 'EVO_TEAM', 'EVO_ADMIN'] as const

export const getRoleColor = (role: string): RoleChipColor => {
  switch (role) {
    case 'EVO_ADMIN': return 'error'
    case 'EVO_TEAM': return 'primary'
    case 'PSC_TEAM': return 'success'
    case 'FP_USER': return 'default'
    default: return 'default'
  }
}

export const getRoleHexColor = (role: string): string => {
  switch (role) {
    case 'EVO_ADMIN': return '#e91e63' // Red for admin
    case 'EVO_TEAM': return '#2196f3' // Blue for team
    case 'PSC_TEAM': return '#4caf50' // Green for team member
    case 'FP_USER': return '#ff9800' // Orange for FP user
    default: return '#9e9e9e'
  }
}

export const getRoleDisplayName = (role: string): string => {
  switch (role) {
    case 'EVO_ADMIN': return 'Evo Admin'
    case 'EVO_TEAM': return 'Evo Team'
    case 'PSC_TEAM': return 'PSC Team'
    case 'FP_USER': return 'FP User'
    default: return role
  }
}
